export const bestServices = [
    {
        number: "01",
        title: "Create Free Account",
        discription: "Lorem ipsum dolor sit consectetur adipisicing elit. Quod dignissimos a consectetur vero."
    },
    {
        number: "02",
        title: "Fast Customer Support",
        discription: "Lorem ipsum dolor sit consectetur adipisicing elit. Quod dignissimos a consectetur vero."
    }, {
        number: "03",
        title: "VIP Support System",
        discription: "Lorem ipsum dolor sit consectetur adipisicing elit. Quod dignissimos a consectetur vero."
    }, {
        number: "04",
        title: "Secured Platform",
        discription: "Lorem ipsum dolor sit consectetur adipisicing elit. Quod dignissimos a consectetur vero."
    },
]